import { render, staticRenderFns } from "./MarcaCreate.vue?vue&type=template&id=f4adc372&scoped=true&"
import script from "./MarcaCreate.vue?vue&type=script&lang=js&"
export * from "./MarcaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4adc372",
  null
  
)

export default component.exports